import { render, staticRenderFns } from "./BoHeader.vue?vue&type=template&id=1f403d77&scoped=true&"
import script from "./BoHeader.vue?vue&type=script&lang=js&"
export * from "./BoHeader.vue?vue&type=script&lang=js&"
import style0 from "./BoHeader.vue?vue&type=style&index=0&id=1f403d77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f403d77",
  null
  
)

export default component.exports